import { Component, Input } from '@angular/core';
import { MatDivider } from '@angular/material/divider';
import { MatIcon } from '@angular/material/icon';
import {
  MatList,
  MatListItem,
  MatListItemAvatar,
  MatListItemLine,
  MatListItemTitle,
} from '@angular/material/list';

import { ListItem } from '@app/components/shared/rolling-hist-list/model/list-item';

@Component({
  selector: 'faxe-rolling-hist-list',
  imports: [
    MatDivider,
    MatIcon,
    MatList,
    MatListItem,
    MatListItemAvatar,
    MatListItemLine,
    MatListItemTitle,
  ],
  templateUrl: './rolling-hist-list.component.html',
  styleUrl: './rolling-hist-list.component.scss',
})
export class RollingHistListComponent<T> {
  @Input() listItems: ListItem<T>[] = [];
}
